'use client'

import { useInstallPrompt } from '@/hooks/use-install-prompt'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { DownloadSimple } from '@phosphor-icons/react'
import { X } from '@/components/icons/glyphs'

export function InstallPrompt() {
  const { showPrompt, install, dismiss } = useInstallPrompt()

  if (!showPrompt) return null

  return (
    <div className="fixed top-4 left-4 right-4 z-50 animate-in slide-in-from-top-4 fade-in duration-300 md:top-auto md:bottom-6 md:left-auto md:right-6 md:max-w-sm md:slide-in-from-bottom-4">
      <Card className="flex-row items-center gap-3 rounded-2xl py-0 p-4 shadow-lg">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/12">
          <DownloadSimple className="h-5 w-5 text-primary" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium">Add Haven to your home screen</p>
          <p className="text-xs text-muted-foreground">Open Haven like any other app</p>
        </div>
        <Button
          size="sm"
          className="shrink-0 rounded-full"
          onClick={install}
        >
          Install
        </Button>
        <Button
          variant="ghost"
          size="icon-sm"
          onClick={dismiss}
          className="shrink-0 text-muted-foreground hover:text-foreground"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </Button>
      </Card>
    </div>
  )
}
